
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      insightTimeout: "",
      series: [44, 55, 13, 43, 22],

      chartOptions: {
        chart: {
          width: 380,
          type: "pie"
        },
        // plotOptions: {
        //   pie: {
        //     size: 50,
        //     width: "1000px",

        //     labels: {
        //       show: true
        //     }
        //   }
        // },
        // dataLabels: {
        //   enabled: true,
        //   formatter: function(val, opts) {
        //     return ;
        //   }
        // },
        labels: ["Team A", "Team B", "Team C", "Team D", "Team E"],
        legend: {
          // show: false,
          position: "bottom",
          // floating: true,
          horizontalAlign: "center",
          width: "320"
          // offsetY: "20"
        }
      }
    };
  },
  props: {
    showDetailPageLink: {
      default: true
    }
  },
  created() {
    this.$nuxt.$on("order-filter-changed", this.fetchCanellationReasons);
  },
  computed: {
    ...mapState("report", ["reportCanellationReasons"])
  },
  methods: {
    ...mapActions("report", ["getReportCanellationReasons"]),
    fetchCanellationReasons() {
      clearTimeout(this.insightTimeout);
      this.insightTimeout = setTimeout(
        (() => {
          this.getReportCanellationReasons({ backgroundLoad: true });
        }).bind(this),
        this.LOAD_ORDERS_DELAY
      );
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("order-filter-changed");
  }
};
